module.exports = __webpack_public_path__ + "static/img/Img_bg_sustentabilidad-degradado.dbcb758.png";